// extracted by mini-css-extract-plugin
export default {"main":"LoginForm_main__SaiY+","form":"LoginForm_form__hzc4p","header":"LoginForm_header__m5BWb","inputBlock":"LoginForm_inputBlock__KtHFP"};